import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";

const ProductCounter = ({ onSubtract, onAdd, count = 0 }) => {
  return (
    <ActionContainer>
      <CounterButton onClick={onSubtract}>-</CounterButton>
      <CountValue>{count || 0}</CountValue>
      <CounterButton onClick={onAdd}>+</CounterButton>
    </ActionContainer>
  );
};

const ActionContainer = styled.div`
  padding: 0.5rem;
  border-radius: 0.6rem;
  background: ${Colors.lightWhiteSmoke};
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  @media only screen and (max-width: 576px) {
    padding: 0.1rem;
  }
`;

const CounterButton = styled.div`
  display: flex;
  color: ${Colors.aqua};
  justify-content: center;
  align-items: center;
  width: 33.33%;
  font-size: 1rem;
  cursor: pointer;
  @media only screen and (max-width: 640px) {
    padding: 0.2rem;
  }
  @media only screen and (max-width: 576px) {
    font-size: 1rem;
  }
`;

const CountValue = styled(CounterButton)`
  color: ${Colors.arsenic};
  cursor: default;
  font-weight: 500;
`;

export default ProductCounter;
